import script from "./OtpForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OtpForm.vue?vue&type=script&setup=true&lang=ts"

import "./OtpForm.vue?vue&type=style&index=0&id=639a80d0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-639a80d0"]])

export default __exports__